import * as _ from "lodash";
import * as moment from "moment";
import { IAccount, IEmployee } from "../../../services/index";
import { AccountEmployeeService } from "../../../services/accountEmployee.service";
interface IResolve {
    account: IAccount;
    accountEmployees: any;
    employees: IEmployee[];
}

class AccountEmployeesItemController {

    private resolve: IResolve;
    private account: IAccount;
    private accountEmployees: any;
    private accountEmployee: any;
    private employees: IEmployee[];

    constructor(
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private AccountEmployeeService: AccountEmployeeService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.account = this.resolve.account;
        this.employees = this.resolve.employees;
        this.accountEmployees = this.resolve.accountEmployees;
        var accountEmployeeId : string = this.$stateParams['accountEmployeeId'];
        if (accountEmployeeId) {
            this.accountEmployee = <IEmployee>_.find(<any>this.resolve.accountEmployees, { "id": accountEmployeeId });
        } else {
            this.accountEmployee = {};
            // console.log('new accountEmployee');
        }
    }

    endDateBeforeRender($dates) {
        // console.log('endDateBeforeRender');
        const todaySinceMidnight = new Date();
        todaySinceMidnight.setUTCHours(0,0,0,0);
        // console.log($dates);
        // $dates.filter(function (date) {
        //     return date.utcDateValue < todaySinceMidnight.getTime();
        // }).forEach(function (date) {
        //     date.selectable = false;
        // });
    }

    public submitAccountEmployee() {
        this.accountEmployee.dateTimeTo = moment(this.accountEmployee.dateTimeTo).format("YYYY-MM-DD HH:mm");
        if (this.accountEmployee.id === undefined) {
            this.accountEmployee.accountId = this.account.id;
            this.AccountEmployeeService.post(this.accountEmployee).then((data) => {
                this.closeModal();
            });
        } else {
            this.AccountEmployeeService.put(this.accountEmployee.id, this.accountEmployee).then((data) => {
                this.closeModal();
            });
        }
    }

    delete() {
        this.AccountEmployeeService.delete(this.accountEmployee.id).then((data) => {
            this.closeModal();
        });
    }

    private closeModal() {
        this.$state.go('^', {tab: 5}, {reload: true});
    }
}

export const accountEmployeesItemComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: AccountEmployeesItemController,
    template: require('./employees.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/employees/employees.item.component.ts